export const ecosystemSlug = "SALUDTI"; // Replace with your actual ecosystem slug